import { Component, ViewChild } from '@angular/core';
import { CopilotImageFlipperComponent } from './copilot-image-flipper/copilot-image-flipper.component';

const SIDEBAR_COLLAPSED_KEY = 'xwai_sidebar_collapsed';

@Component({
    selector: 'app-copilot',
    templateUrl: './copilot.component.html',
    styleUrls: ['./copilot.component.css'],
    standalone: false
})
export class CopilotComponent {
  @ViewChild('imageFlipper') imageFlipperComponent: CopilotImageFlipperComponent;

  sidebarVisible = false;
  sidebarCollapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  toggleSidebarCollapse() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(this.sidebarCollapsed));
  }

  toggleImageFlipper() {
    if (this.imageFlipperComponent) {
      this.imageFlipperComponent.drawer_visible = !this.imageFlipperComponent.drawer_visible;
    }
  }
}
